import { useMetricsExplorerStateContext } from "@features/metrics-explorer/hooks";
import { type SavedView } from "@features/metrics-explorer/types";
import { IconButton } from "@shared/buttons";
import { TextInput } from "@shared/text-input";

import { SavedViewsMenuRow } from "./saved-views-menu-row";

interface Props {
  savedViews: SavedView[];
  closeMenu(): void;
  enableReordering(): void;
  search: string;
  setSearch(value: string): void;
}

export const SavedViewsList = ({
  savedViews,
  closeMenu,
  enableReordering,
  search,
  setSearch,
}: Props) => {
  const { selectedSavedView } = useMetricsExplorerStateContext();

  return (
    <>
      <div className="px-4 mt-1 mb-2">
        <div className="flex items-center justify-between mb-1">
          <h4 className="text-sm font-bold m-0">Saved views</h4>
          <IconButton
            className="text-cosmic text-xs font-bold px-1"
            leftIcon={<i className="fa-regular fa-sharp fa-bars" />}
            onClick={enableReordering}
          >
            REORDER
          </IconButton>
        </div>
        <TextInput
          className="w-full"
          rightIcon={
            <i className="fa-regular fa-sharp fa-magnifying-glass text-primary" />
          }
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="max-h-[300px] overflow-y-auto">
        {savedViews.map((savedView, index) => (
          <SavedViewsMenuRow
            key={savedView.id}
            savedView={savedView}
            isSelected={savedView.id === selectedSavedView?.id}
            isDefault={index === 0}
            isTemplate={savedView.is_template}
            onClick={() => closeMenu()}
          />
        ))}
      </div>
    </>
  );
};
